// import React, { useEffect } from "react";
// import { Modal } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { bindActionCreators } from "redux";
// import { Actions } from "../../../Action";
// import "./AFModalsStyles.css";
// import MultiSelectCmTwo from "../../MultiSelectCmTwo/MultiSelectCmTwo";
// import { filterDomainsForComponent2 } from "../../../utils";
// import { FetchForceReroute, ForceReroute } from "../../../API/api";
// import { toast } from "react-toastify";

// export function RerouteCm() {
//   const [isLoading, setLoading] = React.useState(false);
//   const [options, setOptions] = React.useState([]);
//   const [experts, setExperts] = React.useState([]);
//   const [expert, setExpert] = React.useState([]);
//   const dispatch = useDispatch();
//   const { advanceFilterModalToggle, cmrDetailedRefresh,cmrIsGoBack } = bindActionCreators(Actions, dispatch);
//   const modalState = useSelector((state) => state.domain);
//   const expertState = useSelector((state) => state.expertRecord);
//   const userState = useSelector((state) => state.user);
//   const [domains, setDomain] = React.useState(filterDomainsForComponent2(userState.cmTopics).filter(obj=>{
//     if(obj.name===expertState.clickedData.domain){
//       return obj;
//     }
//   })[0]);
//   const successMsg = (message) => {
//     return (
//       <>
//         <span style={{ fontSize: "12px" }}>{message}</span>
//       </>
//     );
//   };
//   const onClickSubmit = () => {
//     setLoading(true);
//     let payload ={
//       questionId: expertState.clickedData.questionUuid,
//       expertIds: expert.map(obj=>obj.userUuid),
//       comment: ""
//   }
//   ForceReroute(payload).then(res=>{
//     if (res===undefined) return;
//       if(res=== undefined){
//         advanceFilterModalToggle({ bool: false, value: "" });
//         return;
//       }
//       if(res.data.success){
//         toast.success(successMsg(res.data.message));
//         advanceFilterModalToggle({ bool: false, value: "" });
//         cmrDetailedRefresh('gh');
//         setLoading(false);
//         cmrIsGoBack(false)
//       }
//     })
//   };
//   const fetchUsers = ()=>{
//     if(domains===undefined){
//       advanceFilterModalToggle({ bool: false, value: "" });
//       return;
//     }
//     setOptions([]);
//     setExpert([]);
//     FetchForceReroute(expertState.clickedData.questionUuid,domains.indexId).then(res=>{
//       if (res===undefined) return;
//       if (res.data.success) {
//         let updatedData = res.data.data.users.filter((exp) => {
//           exp.label = exp.firstName + " " + exp.lastName;
//           exp.value = exp.userUuid;
//           exp.name = exp.firstName + " " + exp.lastName;
//           if(exp.questionAssigned){
//             exp.isDisabled = true;
//             exp.label = exp.label+` (${exp.questionStatus})`
//           }
//           return exp;
//         });
//         setOptions(updatedData);
//       }
//     })
//   }
// useEffect(()=>{
//   fetchUsers();
// }, [domains]);
//   return (
//     <>
//       <div>
//         <Modal
//           show={modalState.modalState}
//           size={"md"}
//           style={{marginTop:"5%"}}
//           onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
//           backdrop="static"
//         >
//           <Modal.Header
//             closeButton
//             closeVariant="white"
//             className="modalHeaders"
//           >
//             <Modal.Title style={{ fontSize: "17px" }}>
//             Choose the experts you want to assign this question to:            
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ paddingBottom: "0px" }}>
//             <div style={{ marginTop: "5px", width: "90%", margin: "auto"}}>
//               <div
//                 style={{
//                   display: "flex",
//                   color: "grey",
//                   fontSize: "16px",
//                   alignItems: "center",
//                   justifyContent:'center'
//                 }}
//               >
//                 <div
//                   style={{ width: "20%", textAlign: "left", fontSize: "15px" }}
//                 >
//                   Domains:
//                 </div>
//                 <div style={{marginTop:'12px'}}>
//                   <span >
//                     <MultiSelectCmTwo
//                       disabled={false}
//                       value={domains}
//                       onChangeFunc={(e) => setDomain(e)}
//                       isMulti={false}
//                       options={filterDomainsForComponent2(userState.cmTopics)}
//                     />
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div style={{ marginTop: "5px", width: "90%", margin: "auto"}}>
//               <div
//                 style={{
//                   display: "flex",
//                   color: "grey",
//                   fontSize: "16px",
//                   alignItems: "center",
//                   justifyContent:'center'
//                 }}
//               >
//                 <div
//                   style={{ width: "20%", textAlign: "left", fontSize: "15px" }}
//                 >
//                   Expert:
//                 </div>
//                 <div style={{marginTop:'12px'}}>
//                   <span >
//                     <MultiSelectCmTwo
//                       disabled={false}
//                       value={expert}
//                       onChangeFunc={(e) => setExpert(e)}
//                       isMulti={true}
//                       options={options}
//                     />
//                   </span>
//                 </div>
//               </div>
//             </div>
//             {!isLoading && <div className="mt-2 mb-2" style={{textAlign:'center'}}>
//                             <button className="cancelBtn" onClick={()=>advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;<button className="rerouteBtn"  onClick={()=>onClickSubmit()} disabled={expert.length===0?true:false}>Route</button>
//                         </div>}
//                         {isLoading && 
//                         <div className="mt-2 mb-2" style={{textAlign:'center'}}>
//                             <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Routing...</button>
//                         </div>}
//           </Modal.Body>
//         </Modal>
//       </div>
//     </>
//   );
// }


import React, { useEffect } from "react";
import { Modal, ModalHeader } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./AFModalsStyles.css";
import MultiSelectCmTwo from "../../MultiSelectCmTwo/MultiSelectCmTwo";
import { filterDomainsForComponent2 } from "../../../utils";
import { FetchForceReroute, ForceReroute } from "../../../API/api";
import { toast } from "react-toastify";
import Styles from './reroute.module.css'
import { Select } from "antd";
import ReusableMultiSelect from "../../../NewComponent/ReusableMultiSelect";

const textStyles = {
 fontSize: "16px",
 color: "#2A364A",
 lineHeight: "24px",
 fontWeight: "500",
 wordBreak: 'break-word', overflowWrap: 'break-word',
};
const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};

const textStyles1 = {
 fontSize: "16px",
 color: "#2A364A",
 lineHeight: "24px",
 fontWeight: "500",
 wordBreak: 'break-word', overflowWrap: 'break-word',
 textAlign: "left"
};


export function RerouteCm() {
 const [isLoading, setLoading] = React.useState(false);
 const [options, setOptions] = React.useState([]);
 const [experts, setExperts] = React.useState([]);
 const [expert, setExpert] = React.useState([]);
 const dispatch = useDispatch();
 const { advanceFilterModalToggle, cmrDetailedRefresh, cmrIsGoBack } = bindActionCreators(Actions, dispatch);
 const modalState = useSelector((state) => state.domain);
 const expertState = useSelector((state) => state.expertRecord);
 const userState = useSelector((state) => state.user);
 const [domains, setDomain] = React.useState(filterDomainsForComponent2(userState.cmTopics).filter(obj => {
   if (obj.name === expertState.clickedData.domain) {
     return obj;
   }
 })[0]);
 console.log("expert", expert, options)
 const successMsg = (message) => {
   return (
     <>
       <span style={{ fontSize: "12px" }}>{message}</span>
     </>
   );
 };


 function removeAnsweredAndOpen(users) {
  return users.filter(user => user.questionStatus !== "answered" && user.questionStatus !== "open");
}

 const changeDomain = (e) => {
   let val = filterDomainsForComponent2(userState.cmTopics).find((item) => {
     return e.label === item.value
   })
   setDomain(val)
 }


 const onClickSubmit = () => {
   setLoading(true);
   let payload = {
     questionId: expertState.clickedData.questionUuid,
     expertIds: expert.map(obj => obj.userUuid),
     comment: ""
   }
   ForceReroute(payload).then(res => {
     if (res === undefined) return;
     if (res === undefined) {
       advanceFilterModalToggle({ bool: false, value: "" });
       return;
     }
     if (res.data.success) {
       toast.success(successMsg(res.data.message));
       advanceFilterModalToggle({ bool: false, value: "" });
       cmrDetailedRefresh('gh');
       setLoading(false);
       cmrIsGoBack(false)
     }
   })
 };
 const fetchUsers = () => {
   if (domains === undefined) {
     advanceFilterModalToggle({ bool: false, value: "" });
     return;
   }
   setOptions([]);
   setExpert([]);
   // console.log('domain',domains)
   FetchForceReroute(expertState.clickedData.questionUuid, domains?.indexId).then(res => {
     if (res === undefined) return;
     if (res.data.success) {
       let updatedData = res.data.data.users.filter((exp) => {
         exp.label = exp.firstName + " " + exp.lastName;
         exp.value = exp.userUuid;
         exp.name = exp.firstName + " " + exp.lastName;
         if (exp.questionAssigned) {
           exp.isDisabled = true;
           exp.label = exp.label + ` (${exp.questionStatus})`
         }
         return exp;
       });
       setOptions(updatedData);
     }
   })
 }
 useEffect(() => {
   fetchUsers();
 }, [domains]);


 const changeExpert = (selectedUserUuids) => {
   const selectedExperts = options.filter((option) =>
     selectedUserUuids.includes(option.userUuid)
   );
   setExpert(selectedExperts);
   // console.log("Selected Experts:", selectedExperts);
 };

 const transformedOptions = options.map((option) => ({
  ...option,
  disabled: option.questionStatus === "answered" || option.questionStatus === "open"||option.questionStatus === "rejected"
}));

 return (
   <>
     <div>
       <Modal
         show={modalState.modalState}
         onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
         centered={true}
         size={"lg"}
       // dialogClassName={styles.modalDialog}
       >
         <Modal.Header closeButton>


           <Modal.Title style={modalTitleStyle}>
             <span className="fa fa-user-circle"></span>
             &nbsp;&nbsp;Choose the experts you want to assign this question to
           </Modal.Title>
         </Modal.Header>
         <Modal.Body>
           <div style={{ marginTop: "5px", width: "90%", margin: "auto", marginInline: '0px', }}>


             <div
               style={{
                 display: "flex",
                 // color: "grey",
                 fontSize: "16px",
                 alignItems: "baseline",
                 justifyContent: 'center',
                 marginTop: '10px',
                 fontWeight: '300',
                 gap: 5
               }}
             >
               <div
                 style={textStyles1}
               >
                 Domains:
               </div>
               <div style={{ marginTop: '12px', width: "200px", marginLeft: "20px" }}>
                 <span>
                   {/* <MultiSelectCmTwo
                     disabled={false}
                     value={domains}
                     onChangeFunc={(e) => setDomain(e)}
                     isMulti={true}
                     options={filterDomainsForComponent2(userState.cmTopics)}
                   /> */}
                   <Select
                     labelInValue
                     options={filterDomainsForComponent2(userState.cmTopics)}
                     value={domains}
                     // defaultValue={{ label: 'All', value: null }}
                     onChange={(e) => changeDomain(e)}
                     // defaultvalue={domains}
                     placeholder="Select Domains"
                     popupClassName={Styles.selectCss}
                     size="middle"
                     showSearch
                     filterOption={(input, option) =>
                       (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                     }
                     style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                   // size={"medium"}
                   // width={"100px"}
                   />
                   {/* <ReusableMultiSelect
                     value={domains}
                     onChange={(e) => changeDomain(e)}
                     options={filterDomainsForComponent2(userState.cmTopics)}
                     placeholder="Select Domain"
                     maxTagPlaceholder={`${domains?.length || 0} selected`}
                     allowClear={true}
                     disabled={false}
                   /> */}
                 </span>
               </div>
             </div>
             <div
               style={{
                 display: "flex",
                 // color: "grey",
                 fontSize: "16px",
                 alignItems: "baseline",
                 justifyContent: 'center',
                 marginTop: '10px',
                 fontWeight: '300',
                 gap: 5,
                 marginRight: "0px"
               }}
             >
               <div
                 style={textStyles1}
               >
                 Expert&nbsp;
               </div>
               <div style={{ marginTop: '12px', width: "200px", marginLeft: "36px" }}>
                 <span >


                   {/* <ReusableMultiSelect
                     value={expert}
                     onChange={changeExpert}
                     options={options}
                     placeholder="Select Expert"
                     maxTagPlaceholder={`${expert?.length || 0} selected`}
                     allowClear={true}
                     disabled={false}
                   /> */}
                   <Select
                     size="medium"
                     mode="multiple"
                     allowClear={true}
                     popupClassName={Styles.selectCss}
                     options={transformedOptions}
                     style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                     placeholder="Select Expert"
                     value={expert}
                     onChange={changeExpert}
                     // disabled={disabled}
                     optionLabelProp="label"
                     filterOption={(input, option) =>
                       option?.label?.toLowerCase().includes(input.toLowerCase())
                     }
                     dropdownStyle={{ textAlign: "left" }}
                     maxTagCount={0}
                     maxTagPlaceholder={`${expert?.length || 0} selected`}
                   // allowClear={true}
                   />




                 </span>
               </div>
             </div>
           </div>




           <div
             style={{
               display: "flex",
               // color: "grey",
               fontSize: "16px",
               alignItems: "baseline",
               justifyContent: 'center',
               // marginTop: '10px',
               fontWeight: '300',
               gap: 5,
               marginRight: "0px"
             }}
           >
             <div
               style={textStyles1}
             >
               {/* Expert: */}
             </div>
             <div style={{ width: "200px", marginLeft: "15px" }}>
               {!isLoading && <div className="mt-2 mb-2" style={{ textAlign: 'center' }}>
                 <button
                   style={{
                     padding: '8px 12px 8px 12px',
                     borderRadius: '6px',
                     fontSize: '14px',
                     lineHeight: '24px',
                     fontWeight: 400,
                     boxShadow: ' 0px 1px 2px 0px #1018280D',
                     color: '#2A364A',
                     border: '1px solid  #fff',
                     height: '40px',
                     minWidth: '88px',
                     background: " #F6F7F8",
                     marginBottom: '14px',
                     fontWeight: 400,
                     border: " 1px solid #E0E2E6"


                     //  font-weight: 400;    
                   }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</button>&nbsp;
                 {/* <button className="rerouteBtn" onClick={() => onClickSubmit()} disabled={expert.length === 0 ? true : false}>Route</button> */}
                 <button
                   style={{
                     padding: '8px 12px 8px 12px',
                     borderRadius: '6px',
                     fontSize: '14px',
                     lineHeight: '24px',
                     fontWeight: 400,
                     boxShadow: '0px 1px 2px 0px #1018280D',
                     color: '#FFFFFF',
                     border: '1px solid  #fff',
                     height: '40px',
                     minWidth: '88px',
                     background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                     marginBottom: '14px',
                     marginTop: "15px",
                     cursor:expert.length===0?"not-allowed":"pointer",
                    //  cursor:selectedExpert.length  ? "not-allowed" : "pointer",
                     opacity:expert.length===0?"0.7":"",
                   }}
                   disabled={expert.length === 0 ? true : false}

                   onClick={() => onClickSubmit()}
                 >
                   Route
                 </button>
               </div>}
               {isLoading &&
                 <div className="mt-2 mb-2" style={{ textAlign: 'center' }}>
                   <button    style={{
                     padding: '8px 12px 8px 12px',
                     borderRadius: '6px',
                     fontSize: '14px',
                     lineHeight: '24px',
                     fontWeight: 400,
                     boxShadow: '0px 1px 2px 0px #1018280D',
                     color: '#FFFFFF',
                     border: '1px solid  #fff',
                     height: '40px',
                     minWidth: '88px',
                     background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                     marginBottom: '14px',
                     marginTop: "15px",
                      opacity:"0.7"
                   }} disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Routing...</button>
                 </div>}


             </div>
           </div>
           {/* <div
             className="searchsuggestionModal"
             style={{ textAlign: "end" }}
           >
             <button
               style={{
                 padding: '8px 12px 8px 12px',
                 borderRadius: '6px',
                 fontSize: '14px',
                 lineHeight: '24px',
                 fontWeight: 400,
                 boxShadow: '0px 1px 2px 0px #1018280D',
                 color: '#FFFFFF',
                 border: '1px solid  #fff',
                 height: '40px',
                 minWidth: '88px',
                 background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                 marginBottom: '14px',
                 marginTop: "15px"
               }}
             // onClick={() => onClickSubmit()}
             >
               Submit
             </button>
           </div> */}
         </Modal.Body>
       </Modal>
     </div>
   </>
 );
}
